interface ScreenObservationLayoutProps {
  className?: string;
  fullWidth?: boolean;
  children: React.ReactNode;
}

export const ScreenObservationLayout = ({
  className,
  fullWidth,
  children,
}: ScreenObservationLayoutProps) => {
  return (
    <div className={`${fullWidth ? 'w-full' : ''} ${className}`}>
      {children}
    </div>
  );
};
